var _path, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBulletThreeC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7673 38.276H35.8953V36.586L41.2253 31.464H32.7753V29.202H44.4493V31.256L39.3013 36.17C42.4993 36.56 44.9173 38.718 44.9173 42.098C44.9173 45.894 42.0573 48.312 38.2353 48.312C34.5433 48.312 31.8913 46.05 31.8913 42.15H34.4133C34.4133 44.594 35.9213 46.024 38.2873 46.024C40.7313 46.024 42.3173 44.464 42.3173 42.046C42.3173 39.784 40.7573 38.276 37.7673 38.276Z",
    fill: "#FDFE0C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 75.5,
    width: 75,
    height: 75,
    rx: 37.5,
    transform: "rotate(-180 75.5 75.5)",
    stroke: "url(#paint0_linear_585_951)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.5,
    y: 0.5,
    width: 75,
    height: 75,
    rx: 37.5,
    stroke: "url(#paint1_linear_585_951)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_585_951",
    x1: 114,
    y1: 104.543,
    x2: 114,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.298065,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_585_951",
    x1: 38,
    y1: 28.5428,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.298065,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBulletThreeC);
export default __webpack_public_path__ + "static/media/ic_bulletThreeC.1cb8a79bd43bcbfb495332930a2880b5.svg";
export { ForwardRef as ReactComponent };